import { auth } from "./../../../server";

import { getDBUser } from "../../../api/services/userService.js";
import firebase from "firebase/app";
export default {
  state: {
    user: null,
    dbuser: null,
    showOverlay: false
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setDBUser(state, payload) {
      state.dbuser = payload;
    },
    setShowOverlay(state, payload) {
      state.showOverlay = payload;
    }
  },
  actions: {
    async signUserUp({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        auth
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then(async user => {
            // commit("setLoading", false); this line causes an error
            const newUser = {
              id: user.user.uid,
              name: user.user.displayName,
              email: user.user.email,
              photoUrl: user.user.photoURL
            };
            commit("setUser", newUser);
            getDBUser(newUser.id).onSnapshot(dbuser => {
              if (dbuser.exists)
                if (dbuser.exists) commit("setDBUser", dbuser.data());
              resolve();
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async signUserIn({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithEmailAndPassword(payload.email, payload.password)
          .then(async res => {
            const newUser = {
              id: res.user.uid,
              name: res.user.displayName,
              email: res.user.email,
              photoUrl: res.user.photoURL,
              emailVerified: res.user.emailVerified
            };
            commit("setUser", newUser);
            getDBUser(newUser.id).onSnapshot(dbuser => {
              if (dbuser.exists)
                if (dbuser.exists) commit("setDBUser", dbuser.data());
              resolve();
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async signUserInFacebook({ commit }) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithPopup(new firebase.auth.FacebookAuthProvider())
          .then(async user => {
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            };
            commit("setUser", newUser);
            getDBUser(newUser.id).onSnapshot(dbuser => {
              if (dbuser.exists)
                if (dbuser.exists) commit("setDBUser", dbuser.data());
              resolve();
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async signUserInGoogle({ commit }) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithPopup(new firebase.auth.GoogleAuthProvider())
          .then(async user => {
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL
            };
            commit("setUser", newUser);
            getDBUser(newUser.id).onSnapshot(dbuser => {
              if (dbuser.exists)
                if (dbuser.exists) commit("setDBUser", dbuser.data());
              resolve();
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    async autoSignIn({ commit }, payload) {
      commit("setUser", {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      });
      getDBUser(payload.uid).onSnapshot(dbuser => {
        if (dbuser.exists)
          if (dbuser.exists) commit("setDBUser", dbuser.data());
      });
    },
    resetPasswordWithEmail(payload) {
      const { email } = payload;
      auth
        .sendPasswordResetEmail(email)
        .then(() => {
          throw "Email Sent";
        })
        .catch(error => {
          throw error;
        });
    },
    logout({ commit }) {
      auth.signOut();
      commit("setUser", null);
      commit("setDBUser", null);
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    dbuser(state) {
      return state.dbuser;
    },
    showOverlay(state) {
      return state.showOverlay;
    }
  }
};
